<!--  -->
<template>
  <v-main id="dashboard" class="pt-0 pb-10 mb-16" role="presentation">
    <v-container class="text-white mb-16">
      <DashboardMessageSlider />
      <TermLifeCard />
      <InvestmentsCard />
      <DebtSolutionsCard />
      <ContactRepFooter v-if="$vuetify.display.width < 1264 && agent" />
      <WhyPrimerica :is-canada-policy="isCanadian" />
    </v-container>
  </v-main>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import DashboardMessageSlider from './components/DashboardMessageSlider.vue';
import TermLifeCard from './components/TermLife/TermLife.vue';
import InvestmentsCard from './components/Investments/InvestmentsCard.vue';
import DebtSolutionsCard from './components/DebtSolutionsCard/DebtSolutionsCard.vue';
import WhyPrimerica from './components/WhyPrimerica/WhyPrimerica.vue';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { COUNTRIES } from '@/shared/models/constants.models';
import ContactRepFooter from '@/components/ContactRep/ContactRepFooter.vue';
import { mapState, mapStores } from 'pinia';

const componentOptions: ComponentOptions = {
  name: 'DashboardPage',
  components: {
    DashboardMessageSlider,
    TermLifeCard,
    InvestmentsCard,
    DebtSolutionsCard,
    WhyPrimerica,
    ContactRepFooter,
  },
  computed: {
    ...mapStores(useGlobalStore, usePolicyStore, useCustomerStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    isCanadian(): boolean {
      return this.customerProfile.country === COUNTRIES.CANADA;
    },
    agent() {
      return this.globalStore.agents?.length === 1 ? this.globalStore.agents[0] : null;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.container {
  max-width: 960px !important;
  height: 100%;
}
.my-support-dashboard {
  display: block;
  @media only screen and (min-width: 1264px) {
    display: none;
  }
}
</style>
